import { render } from "./HistoryOfBids.vue?vue&type=template&id=5523f237&ts=true"
import script from "./HistoryOfBids.vue?vue&type=script&lang=ts"
export * from "./HistoryOfBids.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__